<template>
  <div class="notif-body">
    <div class="wording" v-if="notif.payload.jsoncontent.postTitle !== ''">
      <span class="notif-link" @click="goToUserInfo">{{ notif.payload.jsoncontent.user.firstName }} {{ notif.payload.jsoncontent.user.lastName }}</span>
      <span>&nbsp;{{ $t('notification.notifCommentPostICommented.hasCommentedThePost') }}&nbsp;</span>
      <span class="notif-link" @click="goToPost">{{ truncateText(notif.payload.jsoncontent.postTitle, 'notification.notifCommentPostICommented.post') }}</span>
      <span> {{ $t('notification.notifCommentPostICommented.youHaveCommentedIn') }} </span>
      <span class="notif-link" @click="goToCommunity">{{ truncateText(notif.payload.jsoncontent.CommunityName) }}</span>
    </div>
    <div class="wording" v-else>
      <span class="notif-link" @click="goToUserInfo">{{ notif.payload.jsoncontent.user.firstName }} {{ notif.payload.jsoncontent.user.lastName }}</span>
      <span>&nbsp;{{ $t('notification.notifCommentPostICommented.hasCommentedThe') }}&nbsp;</span>
      <span class="notif-link" @click="goToPost">{{ $t('notification.notifCommentPostICommented.post') }}</span>
      <span> {{ $t('notification.notifCommentPostICommented.youHaveCommentedIn') }} </span>
      <span class="notif-link" @click="goToCommunity">{{ truncateText(notif.payload.jsoncontent.communityName) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotifCommentPostICommented',
  props: {
    notif: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUserInfo () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'userInfo', params: { id: this.notif.payload.jsoncontent.user.id } })
    },
    goToCommunity () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'communityPage', params: { id: this.notif.payload.jsoncontent.idCommunity } })
    },
    goToPost () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'postPage', params: { id: this.notif.payload.jsoncontent.postId } })
    },
    truncateText (str, defaultStr) {
      if (!str) {
        return this.$t(defaultStr)
      }
      if (str.length > 50) {
        return str.substring(0, 47) + '...'
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="scss" src="./NotifStyle.scss"></style>
